// Function to animate counting up
function animateCounter(element, targetValue, duration = 2000) {
  // Parse the target value into numeric component and suffix
  const valueText = targetValue.trim();
  let numericValue = '';
  let prefix = '';
  let suffix = '';
  
  // Extract numeric value and any prefix/suffix
  if (valueText.startsWith('$') || valueText.includes('$')) {
    if (valueText.startsWith('$')) {
      prefix = '$';
      numericValue = valueText.substring(1).replace(/[^0-9.]/g, '');
    } else {
      numericValue = valueText.replace(/[^0-9.]/g, '');
      suffix = '$';
    }
  } else if (valueText.endsWith('%')) {
    numericValue = valueText.substring(0, valueText.length - 1).replace(/[^0-9.]/g, '');
    suffix = '%';
  } else if (valueText.endsWith('x')) {
    numericValue = valueText.substring(0, valueText.length - 1).replace(/[^0-9.]/g, '');
    suffix = 'x';
  } else if (valueText.includes('lbs')) {
    numericValue = valueText.replace(/[^0-9.]/g, '');
    suffix = 'lbs';
  } else {
    numericValue = valueText.replace(/[^0-9.]/g, '');
  }
  
  // Convert to a number for animation
  const targetNum = parseFloat(numericValue);
  
  // Start from zero
  let startNum = 0;
  let startTime = null;
  // Set initial value to 0 with prefix/suffix
  element.textContent = `${prefix}0${suffix}`;
  
  // Animation function
  function updateCounter(timestamp) {
    if (!startTime) startTime = timestamp;
    
    const progress = Math.min((timestamp - startTime) / duration, 1);
    const currentNum = Math.floor(progress * (targetNum - startNum) + startNum);
    
    // Update the element text with the current number and preserve prefix/suffix
    element.textContent = `${prefix}${currentNum}${suffix}`;
    
    if (progress < 1) {
      // Continue the animation
      requestAnimationFrame(updateCounter);
    } else {
      // Ensure final value is exactly the target text
      element.textContent = valueText;
    }
  }
  
  // Start the animation
  requestAnimationFrame(updateCounter);
}

// Initialize counters when they become visible
function initializeCounters(containerSelector) {
  const statsSection = document.querySelector(containerSelector);
  if (!statsSection) return;
  
  // Get all statistic values in this section
  const statElements = statsSection.querySelectorAll('.statistic-value');
  
  // Reset all statistic values to 0 immediately
  statElements.forEach(element => {
    const targetValue = element.getAttribute('data-value');
    // Set to zero but maintain prefix/suffix format
    const valueText = targetValue.trim();
    let prefix = '';
    let suffix = '';
    
    if (valueText.startsWith('$')) {
      prefix = '$';
    } else if (valueText.includes('$')) {
      suffix = '$';
    } else if (valueText.endsWith('%')) {
      suffix = '%';
    } else if (valueText.endsWith('x')) {
      suffix = 'x';
    } else if (valueText.includes('lbs')) {
      suffix = 'lbs';
    }
    
    element.textContent = `${prefix}0${suffix}`;
  });
  
  // Use Intersection Observer to detect when individual statistics are visible
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const element = entry.target;
        const originalValue = element.getAttribute('data-value');
        animateCounter(element, originalValue);
        
        // Unobserve after triggering the animation
        observer.unobserve(element);
      }
    });
  }, { threshold: 0.1 }); // Lower threshold for better mobile triggering
  
  // Observe each individual statistic element
  statElements.forEach(element => {
    observer.observe(element);
  });
}

// Export the functions globally
window.SiloCounter = {
  animateCounter,
  initializeCounters

};